import { type CurrencyName } from '@webapp/models/enums'
import { BillItemTaxAmountPopoverContent } from './BillItemTaxAmountPopoverContent'
import { BillItemTaxExceedsSubtotalPopoverContent } from './BillItemTaxExceedsSubtotalPopoverContent'
import { BillItemTaxVarianceThresholdPopoverContent } from './BillItemTaxVarianceThresholdPopoverContent'

interface BillItemTaxOverridePopoverContentProps {
  exceedsSubtotal: boolean
  exceedsVariance: boolean
  calculatedTaxAmount: Nullable<number>
  currencyName: CurrencyName
}

export const BillItemTaxOverridePopoverContent = ({
  exceedsSubtotal,
  exceedsVariance,
  calculatedTaxAmount,
  currencyName,
}: BillItemTaxOverridePopoverContentProps) => {
  if (exceedsSubtotal) {
    return (
      <BillItemTaxExceedsSubtotalPopoverContent
        calculatedTaxAmount={calculatedTaxAmount}
        currencyName={currencyName}
      />
    )
  }
  if (exceedsVariance) {
    return (
      <BillItemTaxVarianceThresholdPopoverContent
        calculatedTaxAmount={calculatedTaxAmount}
        currencyName={currencyName}
      />
    )
  }
  return (
    <BillItemTaxAmountPopoverContent
      calculatedTaxAmount={calculatedTaxAmount}
      currencyName={currencyName}
    />
  )
}

BillItemTaxOverridePopoverContent.displayName =
  'BillItemTaxOverridePopoverContent'
